<template>
    <div>
        <div @click="bzbTracking('phone')">
            <a :href="`tel:${getAiaPhoneUrl(lbl.tel_content)}`" class="aboutus-card"
                :class="[{'aboutus-card-mass': theme == 'mass'}, {'aboutus-card-prestige': theme == 'prestige'}]">
                <div class="aboutus-card-wrapper">
                    <div id="aboutus_tel" class="aboutus-subject">
                        {{lbl.tel}}
                    </div>
                    <div class="aboutus-content">
                        <div class="content-ic">
                            <img class="img-fluid" src="./asset/mass/ic-call@3x.png" v-if="theme == 'mass'" />
                            <img class="img-fluid" src="./asset/prestige/ic-phone.svg" v-if="theme == 'prestige'" />
                        </div>
                        <div class="content-txt">
                            <a :href="`tel:${getAiaPhoneUrl(lbl.tel_content)}`">{{lbl.tel_content}}</a>
                        </div>
                    </div>
                </div>
            </a>
        </div>

        <div class="aboutus-card aboutus-card-prestige"
            v-if="theme == 'prestige'"
            @click="clickCard('web')">
            <div class="aboutus-card-wrapper">
                <div class="aboutus-subject">
                    {{lbl.open_web}}
                </div>
                <div class="aboutus-content">
                    <div class="content-ic">
                        <img class="img-fluid" src="./asset/prestige/ic-web.svg" />
                    </div>
                    <div class="content-txt">
                        <div @click="clickCard('web')">{{lbl.open_web_content}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div @click="bzbTracking('email')">
            <a :href="`mailto:${getAiaEmailUrl(lbl.email_address)}`" class="aboutus-card aboutus-card-prestige"
                v-if="theme == 'prestige'">
                <div class="aboutus-card-wrapper">
                    <div class="aboutus-subject">
                        {{lbl.email}}
                    </div>
                    <div class="aboutus-content">
                        <div class="content-ic">
                            <img class="img-fluid" src="./asset/prestige/ic-email.svg" />
                        </div>
                        <div class="content-txt">
                            <a :href="`mailto:${getAiaEmailUrl(lbl.email_content)}`">{{lbl.email_content}}</a>
                        </div>
                    </div>
                </div>
            </a>
        </div>

        <div class="aboutus-card"
            :class="[{'aboutus-card-mass': theme == 'mass'}, {'aboutus-card-prestige': theme == 'prestige'}]"
            @click="clickCard('term')">
            <div class="aboutus-card-wrapper">
                <div class="aboutus-content about-content-bold">
                    <div class="content-ic">
                        <img class="img-fluid" src="./asset/mass/ic-termcond-aia@3x.png" v-if="theme == 'mass'" />
                        <img class="img-fluid" src="./asset/prestige/ic-termcond-prestige.svg" v-if="theme == 'prestige'" />
                    </div>
                    <div class="content-txt" v-html="lbl.term"></div>
                </div>
            </div>
        </div>

        <div class="aboutus-card aboutus-card-prestige"
            v-if="theme == 'prestige'"
            @click="clickCard('privilege')">
            <div class="aboutus-card-wrapper">
                <div class="aboutus-content about-content-bold">
                    <div class="content-ic">
                        <img class="img-fluid" src="./asset/prestige/ic-termcond-aia.svg" />
                    </div>
                    <div class="content-txt" v-html="lbl.privilege"></div>
                </div>
            </div>
        </div>

        <div class="aboutus-card"
            :class="[{'aboutus-card-mass': theme == 'mass'}, {'aboutus-card-prestige': theme == 'prestige'}]"
            @click="clickCard('faq')">
            <div class="aboutus-card-wrapper">
                <div class="aboutus-content about-content-bold">
                    <div class="content-ic">
                        <img class="img-fluid" src="./asset/mass/ic-faq@3x.png" v-if="theme == 'mass'" />
                        <img class="img-fluid" src="./asset/prestige/ic-faq.svg" v-if="theme == 'prestige'" />
                    </div>
                    <div class="content-txt">
                        {{lbl.faq}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Account from '@/helper/AccountHelper.js';
export default {
    name: 'AboutUsCard',
    computed: {
        tier: function () {
            return this.$store.state.tier;
        },
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        lblAbout: Object,
        modalController: Object
    },
    data: function () {
        return {
            lbl: {},
            trackingService: new TrackingService(this),
            profileExtensionJson: Account.getCacheProfileExtensionJson(),
            channel: ''
        };
    },
    created: function () {
        console.log(this.lblAbout);
        this.lbl = this.lblAbout[this.theme];
        this.channel = this.profileExtensionJson.Tier.CHANNEL;
    },
    methods: {
        //event
        clickBack: function () {
            this.$router.back();
        },
        clickCard: function (type) {
            switch(type) {
                case 'term':
                    this.bzbTracking(type)
                    this.openTermsModal('terms');
                    break;
                case 'privilege':
                    this.bzbTracking(type)
                    this.openTermsModal('privilege');
                    break;
                case 'web':
                    this.bzbTracking(type)
                    window.open(this.lblAbout.open_web_address);
                    break;
                case 'faq':
                    this.bzbTracking(type)
                    this.$router.push('/faq');
                    break;
            }
        },
        //method
        openTermsModal: function (termsContent) {
            this.modalController.termsModal
                                .clearController()
                                .setTag('about')
                                .setTermsContent(termsContent)
                                .show();
        },
        getAiaPhoneUrl: function (contactNumber) {
            var tel = contactNumber.replace(/\s/g, '');
            return tel
            
            // if (this.channel == 'aiaplus') {
            //     return Vue.bzbsConfig.aiaPlusPhoneUrl + tel;
            // } else {
            //     return Vue.bzbsConfig.aiaPhoneUrl + tel;
            // }
        },
        getAiaEmailUrl: function (email) {
            var tmpEmail = encodeURIComponent(email);
            return tmpEmail
            // if (this.channel == 'aiaplus') {
            //     return Vue.bzbsConfig.aiaPlusEmailUrl + tmpEmail;
            // } else {
            //     return Vue.bzbsConfig.aiaEmailUrl + tmpEmail;
            // }
        },
        getAiaWebsiteUrl: function (webUrl) {
            var tmpWebUrl = encodeURIComponent(webUrl);
            if (this.channel == 'aiaplus') {
                return Vue.bzbsConfig.aiaPlusWebsiteUrl + tmpWebUrl;
            } else {
                return Vue.bzbsConfig.aiaWebsiteUrl + tmpWebUrl;
            }
        },
        bzbTracking: function(type) {
            var trackingEventCategory = 'about_us'
            var eventName = ''
            var tracking_label = ''
            switch(type) {
                case 'phone':
                    eventName = 'click_call_center'
                    tracking_label = 'AIA Callcenter'
                    break;
                case 'web':
                    eventName = 'click_aia_website'
                    tracking_label = 'AIA Website'
                    break;
                case 'email':
                    eventName = 'click_aia_email'
                    tracking_label = 'AIA Email'
                    break;
                case 'term':
                    eventName = 'click_aia_terms1'
                    tracking_label = 'AIA Terms1'
                    break;
                case 'privilege':
                    eventName = 'click_aia_terms2'
                    tracking_label = 'AIA Terms2'
                    break;
                case 'faq':
                    eventName = 'click_q&a'
                    tracking_label = 'Q&A'
                    break;
            }
            this.trackingService.event(trackingEventCategory, eventName, tracking_label, null)
        }
    },
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
.aboutus-card {
    .aboutus-content {
        .content-txt {
            a {
                text-decoration: none;
            }
        }
    }

    &.aboutus-card-mass {
        color: $mass_detail_font_color;
        background: #d6d8da;

        .content-txt {
            a {
                color: $mass_detail_font_color;
            }
        }
    }

    &.aboutus-card-prestige {
        color: $prestige_font_color;
        background: #ffffff;

        .content-txt {
            a {
                color: $prestige_font_color;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.aboutus-card {
    position: relative;
    display: block;
    height: 80px;
    margin-bottom: 10px;
    border-radius: 10px;

    .aboutus-card-wrapper {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        padding: 10px 15px;
        transform: translateY(-50%);
        //font
        text-decoration: none;
    }

    .aboutus-subject {
        margin-bottom: 8px;
        //font
        font-size: 1.3rem;
        // font-family: $heading;
        // line-height: 1;
    }

    .aboutus-content {
        @extend %display-flex;

        .content-ic {
            width: 30px;
            flex: 0 0 30px;
            margin: {
                top: auto;
                bottom: auto;
            };
        }

        .content-txt {
            width: calc(100% - 30px);
            flex: 0 0 calc(100% - 30px);
            padding-left: 12px;
            margin: {
                top: auto;
                bottom: auto;
            };
            //font
            font-size: 1.3rem;
            // font-family: $everest_condensed;
            // line-height: 1;
            word-break: break-word;
        }

        &.about-content-bold .content-txt {
            font-size: 1.3rem;
            // font-family: $heading;
        }
    }

    &.aboutus-card-mass {
        color: $mass_detail_font_color;
        background: #d6d8da;
    }

    &.aboutus-card-prestige {
        color: $prestige_font_color;
        background: #ffffff;
    }
}
</style>
